import ImmutableModel from '../common/immutable.model';

/**
 * An authentication method like bank or mobiilivarmenne.
 */
class AuthMethod extends ImmutableModel {
  /**
   * @param {string} name
   * @param {string} logo_url
   * @param {string} auth_id
   */
  constructor(
    name,
    logo_url,
    auth_id,
  ) {
    super();

    this.name = name;
    this.logo_url = logo_url;
    this.auth_id = auth_id;
  }

  copy() {
    return new AuthMethod(
      this.name,
      this.logo_url,
      this.auth_id,
    );
  }
}

export default AuthMethod;
